module.exports = __webpack_public_path__ + "img/chinesecompany175.e82c95ab.png";